import React from "react";
import "./About.css";

import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import transition from "../../transition";

import RevealHeading from "../shared/RevealHeading";
import PortraitReveal from "../shared/PortraitReveal";
import Seo from "../../seo/Seo";
import { personJsonLd, breadcrumbJsonLd } from "../../seo/site";
import { useLang, useTranslations, langPath } from "../../i18n";

const ease = [0.83, 0, 0.17, 1];

const About = () => {
  const lang = useLang();
  const t = useTranslations();
  const a = t.about;

  return (
    <motion.div className="Home page">
      <Seo
        lang={lang}
        path="/about"
        title={t.seo.aboutTitle}
        description={t.seo.aboutDesc}
        jsonLd={[
          personJsonLd,
          breadcrumbJsonLd([
            { name: t.nav.index, path: `/${lang}` },
            { name: t.nav.about, path: `/${lang}/about` },
          ]),
        ]}
      />
      <div className="bg"></div>
      <h1 className="visually-hidden">
        {a.title1} {a.title2}
      </h1>

      <section className="page-hero">
        <div className="headers">
          <div className="header">
            <RevealHeading delay={-0.25}>{a.title1}</RevealHeading>
            <RevealHeading delay={-0.1}>&nbsp;{a.title2}</RevealHeading>
          </div>
        </div>
        <motion.div
          className="page-hero-meta"
          initial={{ opacity: 0, y: 40, transition: { duration: 1, ease } }}
          animate={{
            opacity: 1,
            y: 0,
            transition: { duration: 1.5, ease, delay: 0.6 },
          }}
        >
          <p>{a.metaRole1}</p>
          <p>{a.metaRole2}</p>
        </motion.div>
      </section>

      <section className="about about-page">
        <div className="about-container">
          <PortraitReveal className="about-portrait" delay={0.2} />
          <div className="about-col about-bio">
            <p>{a.storyLabel}</p>
            <p>{a.storyP1}</p>
            <p>{a.storyP2}</p>
          </div>
          <div className="about-col">
            <div className="about-block">
              <p>{a.servicesLabel}</p>
              <div className="about-list">
                {a.services.map((service) => (
                  <p key={service}>{service}</p>
                ))}
              </div>
            </div>
            <div className="about-block">
              <p>{a.elsewhereLabel}</p>
              <div className="socials">
                <a href="mailto:elmajdoubmounir@gmail.com">
                  {t.home.email} &#8599;
                </a>
                <a
                  href="https://www.linkedin.com/in/elmajdoubmounir/"
                  target="_blank"
                  rel="noreferrer"
                >
                  {t.home.linkedin} &#8599;
                </a>
                <a
                  href="https://www.instagram.com/mejdubmunir"
                  target="_blank"
                  rel="noreferrer"
                >
                  {t.home.instagram} &#8599;
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="journey">
          {a.journey.map((chapter) => (
            <div className="journey-item" key={chapter.label}>
              <div className="journey-label">
                <p>{chapter.label}</p>
              </div>
              <div className="journey-body">
                <p>{chapter.body}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <div className="footer">
        <div className="divider"></div>
        <div className="footer-content">
          <div className="footer-col">
            <Link to={langPath("/contact", lang)}>
              <p>{a.getInTouch} &#8599;</p>
            </Link>
          </div>
          <div className="footer-col">
            <p>
              {a.basedLine1} <br /> {a.basedLine2}
            </p>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default transition(About);
